'use client';

import { Carousel } from '@components/carousel';
import { SmallCard } from '@components/smallCard';

import { SmallCardsCarouselProps } from './types';

export const SmallCardsCarousel = ({
  smallCards,
  cardCustomClassNames,
  title,
  isAnimateLinkIcon,
}: SmallCardsCarouselProps) => {
  return (
    <>
      {!!title && (
        <h2 className="mb-10 text-[44px] leading-[52px] font-medium">
          {title}
        </h2>
      )}

      <Carousel
        loop
        variant="mini"
        countSlidesPerGroup={1}
        spaceBetweenSlides={32}
        countSlider={3}
        navigationButtonsType="square"
        customClassNames={{
          leftButton: title
            ? '!top-[-90px] !right-[68px] !rounded-full !left-auto'
            : '!left-[-40px]',
          rightButton: title
            ? '!top-[-90px] !right-[0] !rounded-full'
            : '!right-[-40px]',
        }}
      >
        {smallCards.map((cardData) => (
          <Carousel.Item>
            <SmallCard
              key={cardData.description}
              {...cardData}
              imageSrc={cardData.imageSrc}
              customClassNames={cardCustomClassNames}
              isAnimateLinkIcon={isAnimateLinkIcon}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  );
};
